const getCurrentCurrency = function() {
	const element = document.querySelector( 'meta[name="_isoCurrency"]' );
	if ( element && element.content ) {
		return element.content;
	}

	return 'de-CH' === document.documentElement.lang ? 'CHF' : 'EUR';
};

const getCurrencyCode = function() {
	const element = document.querySelector( 'meta[name="_currency"]' );
	if ( element && element.content ) {
		return element.content;
	}

	return 'de-CH' === document.documentElement.lang ? 'CHF' : '€';
};

export {
	getCurrentCurrency,
	getCurrencyCode,
};
